import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Link } from 'office-ui-fabric-react/lib/Link';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import { Data } from '../../data/Data';
import { DataRapport } from '../../data/DataRapport';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { SpinnerChargement } from '../Loader/SpinnerChargement';
import { MessageBars } from '../Outils/MessageBars';
import './DetailsListReport.css';

/****************************************************************
 PROPS :
    idRapportCategorie : id de la catégorie du rapport
    typeFormat: type de format du rapport pour le téléchargement
****************************************************************/

let idOperationPerimetre = 0;
let idAgencePerimetre = 0;
let idRegionPerimetre = 0;

var objetState = {
    items: [],
    dateCG: null,
    periodeEnCours: null,
    idCategorieControleGestion: 0,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: null,

    hideMessageBarWarning: true,
    hideMessageBarError: true,
    warningMessage: '',
    errorMessage: ''
};

export class DetailsListReport extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListReportWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListReportWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent() {
        let datePickerCG = null;
        let dateFinPeriode = (this.state.periodeEnCours !== null ? new Date(this.state.periodeEnCours.dateFin) : null);

        if (this.props.idRapportCategorie === this.state.idCategorieControleGestion) {
            datePickerCG = <EUIDatePicker
                label="Période choisie"
                maxDate={dateFinPeriode}
                minDate={new Date(2015, 1, 1)}
                onSelectDate={date => this.setState({ dateCG: Scriba.date().getChaineISOFromDate(date) })}
                style={{ maxWidth: '250px', marginLeft: '10px' }}
                value={this.state.dateCG}
            />;
        }

        return (this.state.enCoursDeTraitement ? <SpinnerChargement label={this.state.messageEnCoursTraitement} /> :
            <div>
                {datePickerCG}
                <DetailsList
                    items={this.state.items}
                    columns={this.columns}
                    selectionMode={SelectionMode.none}
                />
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;

        //#region chargement des columns
        this._chargementColonnes();
        //#endregion
    }

    _chargementColonnes() {
        let columnsTemp = [];
        columnsTemp.push({
            key: 'rapport',
            name: 'Rapport',
            fieldName: 'rapport',
            minWidth: 150,
            maxWidth: 550,
            isResizable: true,
            onRender: (item) => {
                let titre = item.titre;
                return <Link title={titre} onClick={() => this._telechargementRapport(item, 'MHTML')} disabled={this._desactivationRapport(item)}>{titre}</Link>;
            }
        });
        columnsTemp.push({
            key: 'description',
            name: 'Description',
            fieldName: 'description',
            minWidth: 500,
            maxWidth: 950,
            isResizable: true,
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            onRender: (item) => {
                let description = item.commentaire;
                return <span title={description}>{description}</span>;
            }
        });
        columnsTemp.push({
            key: 'export',
            name: 'Export',
            fieldName: 'export',
            minWidth: 100,
            maxWidth: 100,
            isSorted: false,
            onRender: (item) => {
                return (<PrimaryButton onClick={() => this._telechargementRapport(item, this.props.typeFormat)} disabled={this._desactivationRapport(item)}>Télécharger</PrimaryButton>);
            }
        });

        this.columns = columnsTemp;
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des rapports en cours'
        });

        let chargementDesRapports = DataRapport._chargementDesRapports(this.props.idRapportCategorie);

        chargementDesRapports
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    //let listeRapports = responseFetch.reponseAPIobjet[0];
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (responseFetch.reponseAPIobjet[0] !== null ? responseFetch.reponseAPIobjet[0] : []);
                    let periode = responseFetch.reponseAPIobjet[2];
                    let idCategorieControleGestion = responseFetch.reponseAPIobjet[3];

                    this.setState({
                        items: listeItem,
                        dateCG: (periode !== null ? new Date(periode.dateFin) : null),
                        periodeEnCours: periode,
                        idCategorieControleGestion: idCategorieControleGestion,

                        enCoursDeTraitement: false,
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.dateCG = null;
                    stateTemp.periodeEnCours = null;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _telechargementRapport(rapport, typeFormat) {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Téléchargement du rapport en cours'
        });

        let onGetRapport = DataRapport._onGetRapport(typeFormat, rapport, this.state.dateCG);

        onGetRapport
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    if (responseFetch.reponseAPIobjet !== null) {
                        let rapport = Scriba.fichier().Base64VersByteArray(responseFetch.reponseAPIobjet[0]);
                        let titreRapport = responseFetch.reponseAPIobjet[1];

                        this.setState({
                            enCoursDeTraitement: false,
                            hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                            warningMessage: retourVerif.warningMessage,
                            hideMessageBarError: retourVerif.hideMessageBarError,
                            errorMessage: retourVerif.errorMessage
                        });

                        return Scriba.fichier().EnregisterSous(rapport, titreRapport);
                    }
                    else {
                        this.setState({
                            enCoursDeTraitement: false,
                            hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                            warningMessage: retourVerif.warningMessage,
                            hideMessageBarError: retourVerif.hideMessageBarError,
                            errorMessage: retourVerif.errorMessage
                        });
                    }
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.dateCG = null;
                    stateTemp.periodeEnCours = null;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    componentDidMount() {
        this._recuperationPerimetre();
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");

    //        this._recuperationPerimetre();
    //    }

    //    this._chargementColonnes();
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._recuperationPerimetre();
        this._chargementColonnes();
    };

    componentWillUnmount() {
    }

    render = () => {

        const content = this._creationContent();

        return (<div>
            <div className="ms-Grid-row">
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
            </div>
            {content}
        </div>);

    }

    _desactivationRapport(item) {
        let estDesactive = false;
        let estNational = (item.estNational != null ? item.estNational : false);
        let perimetre = item.perimetre;

        if (!estNational) {
            if (idRegionPerimetre === 0 && perimetre === "Région") {
                estDesactive = true;
            }
            else {
                if (idAgencePerimetre === 0 && perimetre === "Agence") {
                    estDesactive = true;
                }
                else {
                    if (idOperationPerimetre === 0 && perimetre === "Opération") {
                        estDesactive = true;
                    }
                }
            }
        }

        return estDesactive;
    }

    _recuperationPerimetre() {
        var verificationSiPerimetreExiste = Data._verificationSiPerimetreExiste();

        verificationSiPerimetreExiste
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let valeurRetour = responseFetch.reponseAPIobjet;
                    let idOperation = valeurRetour[0];
                    let idAgence = valeurRetour[1];
                    let idRegion = valeurRetour[2];

                    idOperationPerimetre = idOperation;
                    idAgencePerimetre = idAgence;
                    idRegionPerimetre = idRegion;
                }
                else {

                }
            });
    }
}